import type { FC, HTMLAttributes, Ref, RefObject } from 'react'
import React, { useRef } from 'react'
import ReactDraggable from 'react-draggable'
import classNames from 'classnames'
import styles from './draggable.module.css'

export interface DraggableProps {
  className?: string
  children: React.ReactNode
}

const Container = ({ ref, className, ...props }: HTMLAttributes<HTMLDivElement> & { ref?: Ref<HTMLDivElement> }) => (
  <div ref={ref} className={classNames(styles.container, className)} {...props} />
)

const Handle = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={classNames(styles.handle, className)} {...props} />
)

export const Draggable: FC<DraggableProps> = props => {
  const { className, children } = props
  const handleMouse = (ev: globalThis.MouseEvent) => ev.preventDefault()
  const containerRef = useRef<HTMLDivElement | null>(null)

  return (
    <ReactDraggable handle="div" nodeRef={containerRef as RefObject<HTMLElement>} onMouseDown={handleMouse}>
      <Container className={className} ref={containerRef}>
        <Handle>{children}</Handle>
      </Container>
    </ReactDraggable>
  )
}

export default Draggable
